import { render, staticRenderFns } from "./MyLogin.vue?vue&type=template&id=f0afadfa&scoped=true"
import script from "./MyLogin.vue?vue&type=script&lang=js"
export * from "./MyLogin.vue?vue&type=script&lang=js"
import style0 from "./MyLogin.vue?vue&type=style&index=0&id=f0afadfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0afadfa",
  null
  
)

export default component.exports